import { useEffect, useId, useRef } from "react";
import { createPortal } from "react-dom";
import { Minus, X } from "lucide-react";
import { appById } from "../desktop/apps";
import { windowId, type DesktopWindowState } from "../desktop/layout";
import { DesktopAppIcon } from "./DesktopAppIcon";
import "./window-overview.css";

type Props = {
  windows: DesktopWindowState[]; activeId: string | null;
  onActivate: (id: string) => void; onMinimize: (id: string) => void; onCloseWindow: (id: string) => void;
  onSave: () => void; onRestore: () => void; onClose: () => void;
};

export function WindowOverview({ windows, activeId, onActivate, onMinimize, onCloseWindow, onSave, onRestore, onClose }: Props) {
  const dialog = useRef<HTMLDialogElement>(null);
  const title = useId();
  useEffect(() => {
    const element = dialog.current;
    const previous = document.activeElement as HTMLElement | null;
    if (!element) return;
    if (element.showModal) element.showModal(); else element.setAttribute("open", "");
    element.querySelector<HTMLButtonElement>("button")?.focus();
    return () => { if (element.open && element.close) element.close(); if (previous?.isConnected) previous.focus(); };
  }, []);
  return createPortal(<dialog ref={dialog} className="window-overview" aria-modal="true" aria-labelledby={title} onCancel={(event) => { event.preventDefault(); onClose(); }} onKeyDown={(event) => { if (event.key === "Escape") { event.preventDefault(); event.stopPropagation(); onClose(); } }}>
    <header><div><p>ÁREA DE TRABALHO</p><h2 id={title}>Visão geral das janelas</h2></div><button type="button" className="icon-action" aria-label="Fechar visão geral" onClick={onClose}><X size={20} /></button></header>
    <div className="overview-actions"><button type="button" className="secondary-button" onClick={onSave}>Salvar disposição</button><button type="button" className="secondary-button" onClick={onRestore}>Restaurar disposição</button></div>
    <div className="overview-grid">{windows.map((item) => {
      const app = appById(item.appId);
      if (!app) return null;
      const id = windowId(item);
      return <article className={`overview-tile${activeId === id ? " active" : ""}`} key={id}>
        <button type="button" className="overview-activate" aria-label={`Ativar ${app.title}`} onClick={() => onActivate(id)}><DesktopAppIcon app={app} /><strong>{app.title}</strong><span>{item.minimized ? "Minimizada" : activeId === id ? "Em primeiro plano" : "Aberta"}</span></button>
        <div className="overview-window-actions"><button type="button" disabled={item.minimized} aria-label={`Minimizar ${app.title} na visão geral`} onClick={() => onMinimize(id)}><Minus size={16} /><span>Minimizar</span></button><button type="button" aria-label={`Fechar ${app.title} na visão geral`} onClick={() => onCloseWindow(id)}><X size={16} /><span>Fechar</span></button></div>
      </article>;
    })}{windows.length === 0 && <p className="overview-empty">Nenhuma janela aberta. Abra um aplicativo pelo Iniciar ou pela busca.</p>}</div>
    <footer>A disposição é local a esta conta e navegador. Restaurar ajusta apenas janelas já abertas — não inicia sessões novas.</footer>
  </dialog>, document.body);
}
